import React from "react";
import TemperatureBar from "./TemperatureBar";

const ForecastSection = ({ forecast = [], dailyForecastArray = [] }) => {
  // Return early if no forecast data
  if (!forecast.length) {
    return (
      <div className="space-y-4">
        <div className="bg-white rounded-lg shadow p-4">
          <p className="text-gray-500">Loading forecast data...</p>
        </div>
      </div>
    );
  }

  // Calculate the range for the temperature bars
  // Exclude the current day to avoid duplication in the forecast list
  const upcomingForecast = dailyForecastArray.slice(1);
  const allTemps = upcomingForecast.flatMap((day) => [
    day.main.temp_min,
    day.main.temp_max,
  ]);
  const minTemp = Math.min(...allTemps);
  const maxTemp = Math.max(...allTemps);

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        {upcomingForecast.map((day, index) => (
          <div key={index} className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <img
                src={`https://openweathermap.org/img/wn/${day.weather.icon}.png`}
                alt={day.weather.description}
                className="w-8 h-8"
              />
              <span>
                {new Date(day.dt_txt).toLocaleDateString("en-US", {
                  weekday: "short",
                })}
              </span>
            </div>
            <div className="flex-1 max-w-[200px]">
              <TemperatureBar
                minTemp={day.main.temp_min}
                maxTemp={day.main.temp_max}
                globalMinTemp={minTemp}
                globalMaxTemp={maxTemp}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ForecastSection;
